import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Balloon = ({ text, isMine, name }) => {
  const data = useStaticQuery(graphql`
    query BaloonQuery {
      site {
        siteMetadata {
          author {
            name
          }
        }
      }
    }
  `)
  return isMine ? (
    <div className="flex flex-nowrap items-start my-4">
      <div className="text-center">
        <StaticImage
          className="mx-auto mb-0 text-center rounded-full z-10"
          imgClassName="px-0"
          layout="fixed"
          formats={["AUTO", "WEBP", "AVIF"]}
          src="../../images/profile.png"
          width={80}
          height={80}
          alt="Profile picture"
        />
        <p className="pt-2 my-0 text-sm text-center">
          {data.site.siteMetadata.author.name}
        </p>
      </div>
      <div className="voice-text voice-text-right">
        <p className="my-0 text-gray-700 font-light">{text}</p>
      </div>
    </div>
  ) : (
    <div className="flex flex-nowrap items-start justify-end my-4">
      <div className="voice-text voice-text-left">
        <p className="my-0 text-gray-700 font-light">{text}</p>
      </div>
      <div className="text-center">
        <StaticImage
          className="mx-auto mb-0 text-center rounded-full z-10"
          imgClassName="px-0 bg-gray-200"
          layout="fixed"
          formats={["AUTO", "WEBP", "AVIF"]}
          src="../../images/silhouette.png"
          width={80}
          height={80}
          alt="Profile picture"
        />
        <p className="pt-2 my-0 text-sm text-center">{name}</p>
      </div>
    </div>
  )
}

export default Balloon
